import { CAMERA_PRESENTER } from '@shoflo/polymer';
import { getSourceValue } from 'utils/broadcastSourceHelper';
import { setMultipleDesiredAttendeeCameraStatuses } from 'actions/Broadcast';
import toggleMultipleAgoraAttendeeCameraStatuses from 'actions/Broadcast/attendees/toggleMultipleAgoraAttendeeCameraStatuses';
import { VENDOR_AGORA } from '@studio/constants';

export default (layers, config = {}) =>
  (dispatch, getState) => {
    const {
      broadcastSources: { sources },
      attendeeCameraStatus
    } = getState();

    // filter layers by camera presenters
    const sceneCameraPresenters = layers.filter(
      layer => layer.source.type === CAMERA_PRESENTER
    );

    const cameraSourcesMap = sources.reduce((accumulator, source) => {
      if (source.type === CAMERA_PRESENTER) {
        accumulator[source._id] = source;
      }

      return accumulator;
    }, {});

    const cameraStatuses = sceneCameraPresenters.reduce(
      (accumulator, cameraPresenter) => {
        const cameraSource = cameraSourcesMap[cameraPresenter.source._id];
        if (cameraSource) {
          const sourceValue = getSourceValue(cameraSource);
          const isCameraOn = attendeeCameraStatus[sourceValue];

          if (isCameraOn === false && !cameraSource.cameraUnavailable) {
            accumulator[sourceValue] = true;
          }
        }
        return accumulator;
      },
      {}
    );
    if (config.vendor === VENDOR_AGORA) {
      dispatch(toggleMultipleAgoraAttendeeCameraStatuses(cameraStatuses));
    } else {
      dispatch(setMultipleDesiredAttendeeCameraStatuses(cameraStatuses));
    }
  };
